import { Route as PLReportRoute } from "@/routes/(pharma)/_layout/reports/pl-report/index";
import { useQuery } from "@tanstack/react-query";
import { getPLReport } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const usePLReportData = () => {
  const searchParams = PLReportRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["pl-report", searchParams],
    queryFn: async () => {
      const response = await getPLReport(
        searchParams.page || 1,
        searchParams.pageSize || 10,
        searchParams.startDate,
        searchParams.endDate
      );
      return {
        items: response.plReportItems,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};